import { matchPath } from 'react-router';
function isMenuActive(activationPathMatch, pathname) {
    if (!activationPathMatch)
        return false;
    var paths = Array.isArray(activationPathMatch)
        ? activationPathMatch
        : [activationPathMatch];
    return paths.some(function (path) {
        return matchPath({
            path: path,
            end: false,
        }, pathname);
    });
}
var findSelectedMenu = function (AppBuilderMenuItems, pathname) {
    var selectedMenuMain = AppBuilderMenuItems.find(function (item) {
        return isMenuActive(item.activationPathMatch, pathname);
    });
    var selectedMenuSub = AppBuilderMenuItems.find(function (item) {
        var _a;
        return (_a = item.children) === null || _a === void 0 ? void 0 : _a.some(function (child) {
            var _a;
            return (_a = child.data) === null || _a === void 0 ? void 0 : _a.some(function (childData) {
                return isMenuActive(childData.activationPathMatch, pathname);
            });
        });
    });
    return selectedMenuMain || selectedMenuSub;
};
export default findSelectedMenu;
